import { render } from "./ModalUnitAdd.vue?vue&type=template&id=9298e3e0"
import script from "./ModalUnitAdd.vue?vue&type=script&lang=js"
export * from "./ModalUnitAdd.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__